import { Component, EventEmitter, Input, Output, OnInit } from "@angular/core";
import PNotify from "pnotify/dist/es/PNotify";
import PNotifyButtons from "pnotify/dist/es/PNotifyButtons";
import Swal from "sweetalert2";

import { Router } from "@angular/router";
import { User, UserService, Community } from "../../../../shared";

@Component({
  selector: "community-card",
  templateUrl: "./community-card.component.html",
  styleUrls: [
    "./community-card.component.scss",
    "../../../../../assets/icon/icofont/css/icofont.scss",
  ],
})
export class CommunityCardComponent implements OnInit {
  private defaultCommunityImg: string =
    "../../../../../assets/images/uMuzi/hut.png";
  private defaultUserImg: string =
    "../../../../../assets/images/uMuzi/african-mask.png";
  public currentUser: User;
  public isFounder: boolean;

  constructor(private router: Router, private userService: UserService) {
    PNotifyButtons; // Initiate the module. Important!
    PNotify.defaults.styling = "bootstrap4"; // Bootstrap version 4
    PNotify.defaults.icons = "fontawesome4"; // Font Awesome 4
  }
  @Input() community: Community;
  @Output() onToggleFollowing = new EventEmitter<boolean>();

  ngOnInit() {
    this.compareFounderVSLoggedUser();
    this.onRouteChange();
  }

  public onRouteChange() {
    this.router.events.subscribe((event) => {
      if (event) {
        this.compareFounderVSLoggedUser();
      }
    });
  }

  public compareFounderVSLoggedUser() {
    this.userService.currentUser.subscribe((userData: User) => {
      this.currentUser = userData;
      this.isFounder =
        this.currentUser.username === this.community.founder.username;
    });
  }

  public joinCommunityAlert() {
    Swal.fire({
      title: "Eish!",
      text: "Joining uMuzis is invite only, please ask a friend who is already a member to invite you",
      type: "info",
      confirmButtonColor: "#3085d6",
      confirmButtonText: "Mxm, ok!",
    });
  }
}
